export default __webpack_public_path__ + "static/media/FF0000.0ac9e397.svg";